export default __webpack_public_path__ + "static/media/KE.ddc91555.ico";